import { concatBytes } from "./encoding.js";

// Length-prefixed bucket padding applied to plaintext BEFORE encryption, so the
// ciphertext length leaks only a coarse bucket rather than the exact message size.
// Layout: [u32 LE actual length][plaintext][zero fill to bucket].

const BUCKETS = [256, 512, 1024, 2048, 4096, 8192, 16384, 32768, 65536];

export function bucketSize(n: number): number {
  for (const b of BUCKETS) if (n <= b) return b;
  return Math.ceil(n / 65536) * 65536;
}

export function pad(plaintext: Uint8Array): Uint8Array {
  const total = bucketSize(plaintext.length + 4);
  const out = new Uint8Array(total);
  const len = plaintext.length;
  out[0] = len & 0xff;
  out[1] = (len >>> 8) & 0xff;
  out[2] = (len >>> 16) & 0xff;
  out[3] = (len >>> 24) & 0xff;
  out.set(plaintext, 4);
  return out;
}

export function unpad(padded: Uint8Array): Uint8Array {
  if (padded.length < 4) throw new Error("padded buffer too short");
  const len = padded[0] | (padded[1] << 8) | (padded[2] << 16) | (padded[3] << 24);
  if (len < 0 || len + 4 > padded.length) throw new Error("invalid padding length");
  return padded.slice(4, 4 + len);
}

/** Convenience for callers that want to prepend associated framing then pad. */
export const padWithPrefix = (prefix: Uint8Array, plaintext: Uint8Array): Uint8Array =>
  pad(concatBytes(prefix, plaintext));
